import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WEBHOOK } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faPlus } from '@fortawesome/pro-light-svg-icons';

import AddWebhookModal from './AddWebhookModal';

const Webhooks = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'webhookUrl',
				accessor: 'webhookUrl',
				width: 200,
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'status',
				accessor: 'status',
				width: 100,
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_INACTIVE
			},
			{
				Header: 'method',
				accessor: 'method',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WEBHOOK_METHOD,
				width: 50,
				show: true,
				showOnMobile: true
			},
			{
				Header: 'secretKey',
				accessor: 'secretKey',
				width: 200,
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'authorizationKey',
				accessor: 'authorizationKey',
				width: 200,
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'webhookType',
				accessor: 'webhookType',
				width: 150,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WEBHOOK_TYPE
			},
			{
				Header: 'timestampFormat',
				accessor: 'timestampFormat',
				width: 150,
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="webhooks"
				lordIcon={'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Webhooks.json.gz'}>
				<Button
					icon={faPlus}
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
					label="addWebhook"
					onClick={() => NiceModal.show(AddWebhookModal)}
					variant="blue"
					className="addButton"
				/>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.WEBHOOKS}
				columns={columns}
				fetchUrl={WEBHOOK.GET_WEBHOOK_SETTINGS}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="webhooks"
			/>
		</div>
	);
};

export default Webhooks;
